import { Controller } from "@hotwired/stimulus"

// Accessible tab control (WAI-ARIA Tabs pattern): one panel visible at a time,
// arrow/home/end keyboard navigation between tabs, active/inactive classes are
// configurable so the same controller can drive differently-styled tab bars.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]
  static values = { defaultTab: String }

  connect() {
    const initialId = this.hasDefaultTabValue ? this.defaultTabValue : this.tabTargets[0]?.id
    if (initialId) this.activateTab(initialId)
  }

  switch(event) {
    event.preventDefault()
    this.activateTab(event.currentTarget.id)
  }

  navigate(event) {
    const tabs = this.tabTargets
    const currentIndex = tabs.indexOf(event.currentTarget)
    const nextIndexByKey = {
      ArrowRight: (currentIndex + 1) % tabs.length,
      ArrowLeft: (currentIndex - 1 + tabs.length) % tabs.length,
      Home: 0,
      End: tabs.length - 1
    }

    const nextIndex = nextIndexByKey[event.key]
    if (nextIndex === undefined) return

    event.preventDefault()
    const nextTab = tabs[nextIndex]
    this.activateTab(nextTab.id)
    nextTab.focus()
  }

  activateTab(tabId) {
    this.tabTargets.forEach(tab => {
      const isActive = tab.id === tabId
      tab.setAttribute("aria-selected", isActive)
      tab.setAttribute("tabindex", isActive ? "0" : "-1")
      this.activeClasses.forEach(className => tab.classList.toggle(className, isActive))
      this.inactiveClasses.forEach(className => tab.classList.toggle(className, !isActive))
    })

    this.panelTargets.forEach(panel => {
      const isPanelActive = panel.id === `${tabId}-panel`
      panel.classList.toggle("hidden", !isPanelActive)
      panel.setAttribute("aria-hidden", String(!isPanelActive))
    })
  }
}
